import dayjs, { Dayjs } from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);

// deprecated, use formatDate instead.
export const format = (dateString: string | null): string =>
  dateString ? dayjs.utc(dateString).format("YYYY-MM-DD") : "-";

export const formatDate = (
  date: string | Dayjs | null,
  time = false,
): string => {
  if (!date) return "-";

  const d =
    typeof date === "string" ? dayjs.utc(date).local() : date.utc().local();

  const options: Intl.DateTimeFormatOptions = time
    ? {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZoneName: "short",
      }
    : { year: "numeric", month: "short", day: "numeric" };

  return new Intl.DateTimeFormat("en-US", options).format(d.toDate());
};

export const formatWithTime = (dateString: string | null): string =>
  dateString ? dayjs.utc(dateString).format("YYYY-MM-DD HH:mm:ss") : "-";

export const toUtcIso = (date: Dayjs | undefined) =>
  date?.format("YYYY-MM-DDTHH:mm:ss.000Z");

export const hoursUntil = (futureDate: string): string => {
  const now = dayjs();
  const future = dayjs.utc(futureDate).local();
  const hours = Math.max(0, Math.floor(future.diff(now, "hour", true)));

  return `in ${hours} hour${hours !== 1 ? "s" : ""}`;
};
